import { memo } from 'react';
import { Card } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import PropTypes from 'prop-types';
import { NO_DATA } from '../../constants/message.constants';

const EmployeeDevicesDataTable = ({ isLoading, employeeDevicesData }) => {
  const tableColumns = [
    {
      name: <div>EMPLOYEE ID</div>,
      selector: (row) => row.employeeId,
      sortable: true,
      cell: (row) => row.employeeId,
    },
    {
      name: <div>NAME</div>,
      selector: (row) => row.name,
      sortable: true,
      cell: (row) => row.name,
    },
    {
      name: <div>EMAIL</div>,
      selector: (row) => row.email,
      sortable: true,
      cell: (row) => row.email,
      width: '200px',
    },
    {
      name: <div>UUID</div>,
      selector: (row) => row.uuid,
      sortable: false,
      cell: (row) => row.uuid,
      width: '220px',
    },
    {
      name: <div>LOCAL IP</div>,
      selector: (row) => row.localIp,
      sortable: false,
      cell: (row) => row.localIp,
    },
    {
      name: <div>PUBLIC IP</div>,
      selector: (row) => row.publicIp,
      sortable: false,
      cell: (row) => row.publicIp,
    },
    {
      name: <div>PROJECT</div>,
      selector: (row) => row.project,
      sortable: true,
      cell: (row) => row.project,
      width: '200px',
    },
  ];

  return (
    <Card.Body className="p-0">
      <div>
        <DataTable
          columns={tableColumns}
          data={employeeDevicesData}
          noDataComponent={
            isLoading ? (
              ''
            ) : (
              <p className="text-center pt-3">{NO_DATA.EMPLOYEE_DEVICES}</p>
            )
          }
          highlightOnHover
          pagination
          paginationRowsPerPageOptions={[10, 20, 30]}
          paginationComponentOptions={{
            rowsPerPageText: 'Show Results',
            rangeSeparatorText: 'out of',
          }}
        />
      </div>
    </Card.Body>
  );
};

EmployeeDevicesDataTable.propTypes = {
  isLoading: PropTypes.bool,
  employeeDevicesData: PropTypes.array,
};

export default memo(EmployeeDevicesDataTable);
